/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {useSelector} from 'react-redux'
import {StreamBankLink} from "../StreamBankLink";

export const ChildrenListItem = props => {
	const {
		item,
		className = 'unordered',
		key
	} = props;
	
	const {tool = 'summary'} = useSelector(state => state.contextState.context);
	
	return <li key={item?.contextNodeId ?? key} className={className}>
		<StreamBankLink className="link-primary" Href={(item?.link ?? '') + '/' + tool}>{item?.name}</StreamBankLink>
	</li>
}
